import angular from 'angular';

class principalCheckConfigAllCtrl {
  /* @ngInject */
  constructor($state) {
    this.$state = $state;
  }

  backList() {
    this.$state.go('do', { tabName: 'principal' });
  }
}

angular.module('app.principal').component('principalCheckConfigAll', {
  templateUrl: require('./principal-check-config-all.html'),
  controller: principalCheckConfigAllCtrl,
  bindings: {
    principal: '<',
    ladProviders: '<'
  }
});
